var sharedServices = angular.module('sharedServices', ['configService']);

function isValidWeddingId(weddingId) {
    return weddingId !== null && typeof weddingId !== 'undefined' && weddingId !== '' && weddingId !== 'null' && weddingId !== 'undefined';
}

sharedServices.factory('APIInterceptor',function($window) {
     var interceptor = {
        response: function(resp) {
            if(resp.data && resp.data.response && (resp.data.response.message == 'User not logged in.' || resp.data.response.message == 'Invalid Token')){
                localStorage.removeItem('token');
                localStorage.removeItem('vtoken');
                localStorage.removeItem('vendor_logged_in')
                localStorage.removeItem('logged_in');
                $window.location.href = '/';
            }
            if(resp.data && resp.data.response && resp.data.response.message == 'invalid.parameter.token'){
                setTimeout(function(){$window.location.reload()},1000);
            }
            return resp;
        },
        request: function(req) {
          if (/Android|iPhone|iPod/i.test(navigator.userAgent)) {
            req.headers['source'] = '4';
          } else {
            req.headers['source'] = '1';
          }
          return req;
        }
    }
        return interceptor;
});
sharedServices.factory('RecursionHelper', ['$compile', function($compile){
    return {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        compile: function(element, link){
            // Normalize the link parameter
            if(angular.isFunction(link)){
                link = { post: link };
            }

            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                pre: (link && link.pre) ? link.pre : null,
                /**
                 * Compiles and re-adds the contents
                 */
                post: function(scope, element){
                    // Compile the contents
                    if(!compiledContents){
                        compiledContents = $compile(contents);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function(clone){
                        element.append(clone);
                    });

                    // Call the post-linking function, if any
                    if(link && link.post){
                        link.post.apply(null, arguments);
                    }
                }
            };
        }
    };
}]);
sharedServices.factory('albumInfo',function($http,config) {
  var album = function(type) {
      return $http.get(config.domain + '/api/v1/vendor_albums/'+type+'?version=1.1&isSlug=1&token=' + config.token)
  }
  return album;
});

sharedServices.factory('getReviews',function($http,config) {
    var review = function(slug){
        return $http.get(config.domain + '/api/v1/vendor/'+slug+'/reviews?version=1.1&token='+ config.token);
    }
    return review;
});
sharedServices.factory('getSingleReview',function($http,config) {
    var singleReview = function(id, vendor_member_id){
        return $http.get(config.domain + '/api/v1/vendor/review_details/'+id+'?version=1.1&token='+ config.token + '&vendor_member_id=' + vendor_member_id);
    }
    return singleReview;
});

sharedServices.factory('deviceRegister', function($http, config) {
  var deviceRegister = function(os, device_type, device_info) {
      return $http({
          method: 'post',
          url: config.domain + '/api/v1/user/device_register?nocache=1',
          data: {
              'os': os,
              'device_type': device_type,
              'device_info': device_info,
          }
      })
  }
  return deviceRegister;
});
sharedServices.factory('signUp',function($http,config){
    var signup = function(name,email,password,confirm_password) {
        return $http({
            method: 'post',
            url: config.domain + "/api/v1/user/signup?version=1.1&nocache=1&token="+token,
            data: {
                'name': name,
                'email': email,
                'password': password,
                'confirm_password': confirm_password,
            }
        });
    }
    return signup;
})
sharedServices.factory('masters',function($http,config) {
    //http://api.wedmegood.com/api/v1/masters?version=1.1&token=568cbe9de14007.14576961
    var masters = function(token) {
        return $http.get(config.domain + '/api/v1/masters?version=1.1&nocache=1&token='+token);
    }
    return masters;
});
sharedServices.factory('logoutUser',function($http,config) {
    //user/logout?version=" + API_VERSION + "&token=%s";
    var logout = function(token) {
        return $http.get(config.domain+ '/api/v1/user/logout?version=1.1&nocache=1&token='+token)
    }
    return logout;
})
sharedServices.provider('EncryptedLocalStorage', function() {
    var EncryptedLocalStorage = (function(global) {
        'use strict';
        // Constructor
        var EncryptedLocalStorage = function(secret) {
                if (!secret) {
                    throw 'Missing secret!';
                }
                this.secret = secret;
            },
            // Private methods
            encrypt = function(object, secret) {
                var message = JSON.stringify(object);
                return CryptoJS.TripleDES.encrypt(message, secret);
            },
            decrypt = function(encrypted, secret) {
                var decrypted = CryptoJS.TripleDES.decrypt(encrypted, secret);
                var decryptedString = decrypted.toString(CryptoJS.enc.Latin1);
                if (!decryptedString) {
                    return null;
                }
                try {
                    return JSON.parse(decryptedString);
                } catch (e) {
                    return null;
                }
            };
        // Public API
        EncryptedLocalStorage.prototype = {
            get: function(key) {
                var encrypted = global.localStorage.getItem(key);
                return encrypted && decrypt(encrypted, this.secret);
            },
            set: function(key, object) {
                if (!object) {
                    this.remove(key);
                    return;
                }
                var encrypted = encrypt(object, this.secret);
                global.localStorage.setItem(key, encrypted);
            },
            remove: function(key) {
                global.localStorage.removeItem(key);
            }
        };
        return EncryptedLocalStorage;
    }(window));
    var decrypt = function(encrypted, secret) {
        var decrypted = CryptoJS.TripleDES.decrypt(encrypted, secret);
        var decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        if (!decryptedString) {
            return null;
        }
        try {
            return JSON.parse(decryptedString);
        } catch (e) {
            return null;
        }
    };
    var els = new EncryptedLocalStorage('WedMeExcellent');
    var get = function(key) {
        var encrypted = window.localStorage.getItem(key);
        return encrypted && decrypt(encrypted,'WedMeExcellent');
    };
    var some = function() {
        return els;
    }
    return ({
        $get: some,
        get: get,
    })
});

sharedServices.factory('loginAPI', function($http, config) {
    var login = function(token, username, password) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/user/login?version=1.1&nocache=1&token=' + token,
            ignoreLoadingBar: true,
            data: {
                'username': username,
                'password': password,
            }
        })
    }
    return login;
});

sharedServices.factory('requestCallback',function($http,config) {
  var requestCallback = function(vendor_id,get_callback) {
    return $http({
      method: 'post',
      url: config.domain + "/api/v1/request_callback?version=1.1&token=" + config.token,
      data: {
        'vendor_id': vendor_id,
        'get_callback': get_callback
      }
    })
  }
  return requestCallback;
});

sharedServices.factory('claimProfileService',function($http,config) {
  var requestCallback = function(data) {
    return $http({
      method: 'post',
      url: config.domain + "/api/v1/vendor/claimYourProfile?version=1.1&token=" + config.token,
      data: data
    })
  }
  return requestCallback;
});

sharedServices.factory('changePassword',function($http,config) {
  var changePass = function(token,old_password,new_password) {
    return $http({
      method: 'post',
      url: config.domain + "/node/v1/password-change",
      data: {
          'old_password': old_password,
          'password': new_password,
      },
      headers: {
        'token': token,
        'source': 1
      },
    });
  }
  return changePass;
});
sharedServices.factory('editWedding',function($http,config) {
    var editWedding = function(token,title,location,wedding_date) {
        return $http({
            method: 'post',
            url: config.domain + "/api/v1/edit_my_wedding?version=1.1&nocache=1&token="+ token,
            data: {
                'title': title,
                'wedding_date': wedding_date,
                'location': location,
            }
        });
    }
    return editWedding;
});

sharedServices.factory('sendEnquiry',function($http, config) {
  var sendEnquiry = function(wedding_id,vendor_id,message,phone_no,merged,date) {
    return $http({
      method: 'post',
      url: config.domain + '/api/v1/send_enquiry?version=1.1&token=' + config.token,
      data: {
        wedding_id: wedding_id,
        vendor_id: vendor_id,
        requirements: message,
        mobile_no: phone_no,
        source:1,
        merged_modal: merged,
        function_date: date
      }
    })
  }
  return sendEnquiry;
});

sharedServices.factory('getUserInfo', function($http, config,$q, $location) {
    var getInfo = function(token) {
        if(!token){
          // location.replace(location.protocol + '//' + location.host);
          $('#forceLoginModal').modal({
            backdrop: 'static', keyboard: false
          });
          localStorage.preWedding = new Date().getTime() + 20 * 24 * 60 * 60;
          return $q.reject();
        }
        return $http.get(config.domain + '/api/v1/user/profile?version=1.1&nocache=1&token=' + token);
    }
    return getInfo;
});
sharedServices.factory('shortlistedVendors', function($http, config,$q, $location) {
    var shortlistedVendors = function(token) {
        if(!token){
          $('#forceLoginModal').modal({
            backdrop: 'static', keyboard: false
          });
          localStorage.preWedding = new Date().getTime() + 20 * 24 * 60 * 60;
          // openLoginModal();
          return $q.reject();
        }
        return $http.get(config.domain + '/api/v1/vendor_shortlist?version=1.1&nocache=1&token=' + token);
    }
    return shortlistedVendors;
});

sharedServices.factory("getUserGenieData", function($http, config,$q, $location){
	var getUserGenieData = function(token){
    if(!token){
      $('#forceLoginModal').modal({
        backdrop: 'static', keyboard: false
      });
      localStorage.preWedding = new Date().getTime() + 20 * 24 * 60 * 60;
      // location.replace(location.protocol + '//' + location.host);
      return $q.reject();
    }
		return $http.get(config.domain + "/api/v1/booking/user_suggestions/list?version=1.1&token=" + token);
	}
	return getUserGenieData;
});

sharedServices.factory("getVendorSuggestions", function($http, config){
	var getVendorSuggestions = function(token, id, uuid){
		if(uuid){
			return $http.get(config.domain + '/api/v1/booking/user_suggestions?version=1.1&token=' + token + '&id=' + id + '&uuid=' + uuid);
		}
		else{
			return $http.get(config.domain + '/api/v1/booking/user_suggestions?version=1.1&token=' + token + '&id=' + id);
		}
	}
	return getVendorSuggestions;
});

sharedServices.factory("requestVendorSuggestion", function($http, config){
	var postVendorRequest = function(token, id, vendorId){
		return $http({
      method: 'post',
      url: config.domain + '/api/v1/booking/user_suggestions/request?version=1.1&token='+token,
      data: {
        id: id,
        vendor_id: vendorId
      }
    })
	}
	return postVendorRequest;
});

sharedServices.factory('sendOtp',function($http,config) {
  var sendOtp = function(token,phone_no,is_international) {
    return $http({
      method: 'post',
      url:  config.domain + '/api/v1/user/sendotp?version=1.1&token='+ token,
      data: {
        mobile_number : phone_no,
        is_international: is_international
      }
    })
  }
  return sendOtp;
});
sharedServices.factory('verifyMobile',function($http,config) {
  var verifyMobile = function(token,phone_no,otpCode) {
    return $http({
      method: 'post',
      url: config.domain + '/api/v1/user/verifymobile?version=1.1&token=' + token,
      data: {
        mobile_number: phone_no,
        otp: otpCode
      }
    })
  }
  return verifyMobile;
})
sharedServices.factory('getCollabs', function($http, config) {
    var getCollabs = function(token, id) {
        return $http.get(config.domain + '/api/v1/collaborators?version=1.1&nocache=1&wedding_id=' + id + '&token=' + token);
    }
    return getCollabs;
});
sharedServices.factory('addCollabs', function($http, config) {
    var addCollabs = function(token, id, collab_type, mobile, email) {
        if (email) {
            return $http({
                method: 'post',
                url: config.domain + '/api/v1/add_collabrator?version=1.1&nocache=1&token=' + token,
                data: {
                    'code': id,
                    'collaborator_type': collab_type,
                    'email': email,
                }
            });
        } else if (mobile) {
            return $http({
                method: 'post',
                url: config.domain + '/api/v1/add_collabrator?version=1.1&nocache=1&token=' + token,
                data: {
                    'code': id,
                    'collaborator_type': collab_type,
                    'mobile': mobile,
                }
            });
        }
    }
    return addCollabs;
});
sharedServices.factory('deleteCollabs',function($http,config) {
    var deleteCollabs = function(token,wedding_id,id) {
            return $http({
                method: 'post',
                url: config.domain + '/api/v1/remove_collabrator?version=1.1&nocache=1&token=' + token,
                data: {
                    'wedding_id': wedding_id,
                    'collaborator_id': id,
                }
            });
    }
    return deleteCollabs;
});
sharedServices.factory('finalizeV', function($http, config) {
    var finalizeV = function(token, wedding_id, vendor_id, finalize_status) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/vendor/finalize?version=1.1&nocache=1&token=' + token,
            data: {
                'wedding_id': wedding_id,
                'vendor_id': vendor_id,
                'finalize': finalize_status,
            }
        });
    }
    return finalizeV;
})
sharedServices.factory('getWedding', function($http, config) {
    var getWedding = function(token, wedding_id) {
        if (!isValidWeddingId(wedding_id)) {
            return {
                success: function(callback) {
                    if (callback) {
                        callback({response: {status: false}, data: null});
                    }
                    return this;
                }
            };
        }
        return $http.get(config.domain + '/api/v1/get_my_wedding?version=1.1&nocache=1&token=' + token + '&wedding_id=' + wedding_id);
    }
    return getWedding;
});
sharedServices.factory('shortlistVendor',function($http,config) {
    var shortlistThis = function(wedding_id,vendor_id) {
      return $http({
        method: 'post',
        url: config.domain + '/api/v1/add_vendor_shortlist?version=1.1&token=' + config.token,
        data: {
          'wedding_id': wedding_id,
          'vendor_id': vendor_id
        }
      })
    }
    return shortlistThis;
});
sharedServices.factory('unShortlistVendor', ['$http','config', function($http,config){
    return function name(wedding_id,vendor_id){
        return $http({
          method: 'delete',
          url: config.domain + '/api/v1/vendor_shortlist/delete?version=1.1&token='+config.token+'&wedding_id=' + wedding_id + '&vendor_id='+ vendor_id
        })
    };
}])
sharedServices.factory('getLoves', function($http,$timeout, config) {
    var lovesData = function(token, wedding_id) {
        this.items = [];
        this.newItems = [];
        this.busy = false;
        this.after = '';
        this.pageCount = 0;
        this.emptyData = false;
        this.token = token;
        this.wedding_id = wedding_id;
        this.timestamp = new Date().getTime();
        this.currentTimestamp = '';
        this.loves_diff_date = {};
    };
    lovesData.prototype.nextPage = function() {
        if (!isValidWeddingId(this.wedding_id)) {
            this.emptyData = true;
            this.busy = false;
            return;
        }
        if (this.busy) return;
        this.busy = true;
        var url = config.domain + '/api/v1/favorite_list?wedding_id=' + this.wedding_id + '&version=1.1&nocache=1&token=' + this.token + '&timestamp=' + this.timestamp + '&before=1&limit=10&required=medium';
        if (!this.emptyData) {
            $http.get(url).success(function(data) {
                var items = data && angular.isArray(data.data) ? data.data : [];
                if (!data || !data.response || !data.response.status || !items.length) {
                    this.emptyData = true;
                    if (this.pageCount == '0') {
                        this.pageCount = 1;
                        this.currentTimestamp = 0;
                    }
                    this.busy = false;
                    return;
                } else {
                    if (this.pageCount == '0') {
                        this.currentTimestamp = items[0].timestamp;
                    }
                }
                this.pageCount = 2;
                for (var i = 0; i < items.length; i++) {
                    this.items.push(items[i]);
                }
                if (this.items && this.items.length) {
                    var length = this.items.length;
                    this.timestamp = this.items[length - 1].timestamp;
                }
                var datetimes = this.items.map(function(data) {
                    var index = data.datetime.toString().indexOf(' ');
                    return data.datetime.substr(0,index);
                });
                var diff_dates = datetimes.filter(function(itm, i, a) {
                    return i == a.indexOf(itm);
                });
                for (var i = 0; i < diff_dates.length; i++) {
                    this.loves_diff_date[diff_dates[i]] = [];
                    for (var j = 0; j < this.items.length; j++) {
                        var index = this.items[j].datetime.indexOf(' ');
                        var lovedate = this.items[j].datetime.substr(0,index);
                        if (lovedate == diff_dates[i]) {
                            this.loves_diff_date[diff_dates[i]].push(this.items[j]);
                        }
                    }
                }
                    angular.forEach(this.loves_diff_date,function(value,key){
                        for(var i=0; i <value.length;i++) {
                            switch (value[i].type) {
                                case 1:
                                case 4:
                                    // value[i].content.contentUrl = scope.love.content.image_url;
                                    // post_title = scope.love.content.post_title;
                                    break;
                                case 3:
                                    value[i].content.image_url= value[i].content.banner_left;
                                    value[i].content.post_title = value[i].content.title;
                                    // scope.post_desc = scope.love.content.description;
                                    break;
                                case 2:
                                    value[i].content.image_url = value[i].content.profile_pic_url;
                            }
                        }
                    });
                this.busy = false;
            }.bind(this));
        }
    };
    lovesData.prototype.newPage = function() {
        if (!isValidWeddingId(this.wedding_id)) {
            return;
        }
        if (!this.currentTimestamp) {
            return;
        }
        var url = config.domain + '/api/v1/favorite_list?wedding_id=' + this.wedding_id + '&version=1.1&nocache=1&token=' + this.token + '&timestamp=' + this.timestamp + '&before=0&limit=10';
        $http.get(url).success(function(data) {
            var items = data && angular.isArray(data.data) ? data.data : [];
            if (!data || !data.response || !data.response.status || !items.length) {
                return;
            }
            for(var i=0;i<items.length;i++){
                for(var j=0;j<this.items.length;j++) {
                    if(items[i].content.id == this.items[j].content.id) {
                        items.splice(i,1);
                    }
                }
            }
            if (items) {
            for (var i = 0; i < items.length; i++) {
                this.newItems.push(items[i]);
            }
            if (this.newItems && this.newItems.length) {
                this.currentTimestamp = this.newItems[0].timestamp;
            }
        }
        }.bind(this))
    }
    return lovesData;
});
sharedServices.factory('getFeed', function($http,$timeout, config) {
    var feedData = function(token, wedding_id) {
        this.items = [];
        this.newItems = [];
        this.busy = false;
        this.after = '';
        this.pageCount = 0;
        this.emptyData = false;
        this.token = token;
        this.wedding_id = wedding_id;
        this.timestamp = new Date().getTime();
        this.currentTimestamp = '';
    };
    feedData.prototype.nextPage = function() {
        if (!isValidWeddingId(this.wedding_id)) {
            this.emptyData = true;
            this.busy = false;
            return;
        }
        if (this.busy) return;
        this.busy = true;
        if (!this.emptyData) {
            var url = config.domain + '/api/v1' + '/my_wedding/wall?version=1.1' + '&nocache=1&token=' + this.token + '&wedding_id=' + this.wedding_id + '&timestamp=' + this.timestamp + '&before=1&limit=10';
            $http.get(url).success(function(data) {
                var items = data && angular.isArray(data.data) ? data.data : [];
                if (!data || !data.response || !data.response.status || !items.length) {
                    this.emptyData = true;
                    this.busy = false;
                    if (this.pageCount == '0') {
                        this.pageCount = 1;
                        this.currentTimestamp = 0;
                    }
                    return;
                } else {
                    if (this.pageCount == '0') {
                        this.currentTimestamp = items[0].timestamp;
                    }
                }
                this.pageCount = 2;
                for (var i = 0; i < items.length; i++) {
                    this.items.push(items[i]);
                }
                if (this.items && this.items.length) {
                    var length = this.items.length;
                    this.timestamp = this.items[length - 1].timestamp;
                }
                this.busy = false;
            }.bind(this));
        }
    };
    feedData.prototype.newPage = function() {
        if (!isValidWeddingId(this.wedding_id)) {
            return;
        }
        if (!this.currentTimestamp) {
            return;
        }
        var url = config.domain + '/api/v1' + '/my_wedding/wall?version=1.1' + '&nocache=1&token=' + this.token + '&wedding_id=' + this.wedding_id + '&timestamp=' + this.currentTimestamp + '&before=0&limit=10';
        $http.get(url).success(function(data) {
            var items = data && angular.isArray(data.data) ? data.data : [];
            if (!data || !data.response || !data.response.status || !items.length) {
                return;
            }
            // for(var i=0;i<items.length;i++) {
            //     for(var j=0;j<this.items.length;j++) {
            //         if(items[i].content.image_id)
            //     }
            // }
            for (var i = 0; i < items.length; i++) {
                this.newItems.push(items[i]);
            }
            if (this.newItems && this.newItems.length) {
                this.currentTimestamp = this.newItems[0].timestamp;
            }
        }.bind(this))
    }
    return feedData;
});
sharedServices.factory('getUserInfo', function($http, config, $q) {
    var getInfo = function(token) {
        if(!token){
          $('#loginModal').modal({
            backdrop: 'static', keyboard: false
          });
          localStorage.preWedding = new Date().getTime() + 20 * 24 * 60 * 60;
          return $q.reject();
        }
        return $http.get(config.domain + '/api/v1/user/profile?version=1.1&nocache=1&token=' + token);
    }
    return getInfo;
});
sharedServices.factory('joinW',function($http,config) {
    var joinW = function(token,wedding_code) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/join_wedding?version=1.1&nocache=1&token='+token,
            data: {
                'code': wedding_code
            }
        })
    }
    return joinW;
});
sharedServices.factory('createW',function($http,config) {
    var createW = function(token,type,location,date,title) {
        return $http({
                    method:'post',
                    url: config.domain + "/api/v1/add_my_wedding?version=1.1&nocache=1&token=" +token,
                    data: {
                        'user_type': type,
                        'location':location,
                        'wedding_date': date,
                        'title': title,
                    }
                });
    }
    return createW;
});

// sharedServices.factory('inboxData',function($http,config) {
//     //my_wedding/inbox?version=" + API_VERSION + "&token=%s"
//     var inboxData = function(token) {
//         return $http.get(config.domain +  '/api/v1/my_wedding/inbox?version=1.1&nocache=1&token=' + token);
//     }
//     return inboxData;
// });

sharedServices.factory("inboxData", function($http, config){
	var inboxData = function(token){
		this.items = [];
		this.busy = false;
		this.offset = 0;
		this.limit = 15;
		this.noData = false;
		this.token = token;
		this.flag = 0;
	}
	inboxData.prototype.nextPage = function(){
		console.log(this.offset, this.limit);
		if (this.busy) return;
		this.busy = true;
		var url = config.domain +  '/api/v1/my_wedding/inbox?version=1.1&nocache=1&token=' + token + '&offset=' + this.offset + '&limit=' + this.limit;
		$http.get(url).success(function(data){
			console.log(data.data);
			if(data.data.length !== 0){
				var items = data.data;
				for (var i = 0; i < items.length; i++) {
					this.items.push(items[i]);
				}
				this.offset += this.limit;
				this.busy = false;
				this.noData = false;
				this.flag = 1;
			}
			else{
				this.noData = true;
			}
		}.bind(this));
	}
	return inboxData;
});

sharedServices.factory('sendUserMsg',function($http,config) {
    var sendUserMsg = function(token,thread_id,message) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/my_wedding/inbox/compose?version=1.1&nocache=1&token='+token,
            data: {
                'thread_id': thread_id,
                'message': message,
            }
        })
    }

    return sendUserMsg;
});
sharedServices.factory('addUserMsg',function($http,config) {
    var sendUserMsg = function(token,thread_id,member_id) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/my_wedding/inbox/compose?version=1.1&nocache=1&token='+token,
            data: {
                'thread_id': thread_id,
                'member_id': member_id,
            }
        })
    }

    return sendUserMsg;
});
sharedServices.factory('getThreadMsg',function($http,config) {
    return getThreadMsg = function(token,thread_id,offset,limit) {
        return $http.get(config.domain + "/api/v1/my_wedding/inbox/thread_messages?version=1.1&nocache=1&thread_id="+thread_id+'&token='+token+'&offset='+offset);
    }
    return getThreadMsg;
});
sharedServices.factory('postComment', function($http, config) {
    var postComments = function(token, feed_id, comment) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/my_wedding/wall_feed_post_comment?version=1.1&nocache=1&token=' + token,
            data: {
                'feed_id': feed_id,
                'comment': comment,
            }
        })
    }
    return postComments;
});
sharedServices.factory('getComments', function($http, config) {
    var getComments = function(token, feed_id) {
        return $http.get(config.domain + '/api/v1/my_wedding/wall_feed_comments?feed_id=' + feed_id + '&version=1.1&nocache=1&token=' + token);
    }
    return getComments;
});
sharedServices.factory('getChecklist', function($http, config) {
    var getChecklist = function(token, wedding_id) {
        if (!isValidWeddingId(wedding_id)) {
            return {
                success: function(callback) {
                    if (callback) {
                        callback({response: {status: false}, data: null});
                    }
                    return this;
                }
            };
        }
        return $http.get(config.domain + '/api/v1/my_wedding/checklist/' + wedding_id + '?version=1.1&nocache=1&token=' + token);
    }
    return getChecklist;
});
sharedServices.factory('updateChecklist', function($http, config) {
    var updateChecklist = function(checklist_id, wedding_id, task_status, token) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/my_wedding/checklist/updatetaskstatus?version=1.1&nocache=1&token=' + token,
            data: {
                'checklist_id': checklist_id,
                'wedding_id': wedding_id,
                'task_status': task_status,
            }
        })
    }
    return updateChecklist;
});
sharedServices.factory('loveUnlove', function($http, config) {
    var loveit = function(token, content_id, content_type, wedding_id) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/add_favorite_list?version=1.1&nocache=1&token=' + token,
            data: {
                'content_id': content_id,
                'content_type': content_type,
                'wedding_id': wedding_id,
            }
        });
    };
    var unloveit = function(token, content_id, content_type, wedding_id) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/unlove?version=1.1&nocache=1&token=' + token,
            data: {
                'content_id': content_id,
                'content_type': content_type,
                'wedding_id': wedding_id,
            }
        });
    };
    return {
        loveit: loveit,
        unloveit: unloveit
    }
});
sharedServices.factory('imageDetail', function($http, config) {
    var imageDetail = function(imageId, token) {
        return $http.get(config.domain + '/api/v1/gallery/image/' + imageId + '?version=1.1&nocache=1&gallery=1&token=' + token);
    }
    return imageDetail;
});

sharedServices.factory('getBookings',function($http,config) {
    var bookings = function(type,token) {
        return $http.get(config.domain + '/api/v1/transaction/bookings?version=1.1&category_id=10&nocache=1&require='+type+'&token='+ token);
    }
    return bookings;
})

sharedServices.factory('userBooking', function($http, config) {
    var userBooking = function(token) {
        return $http.get(config.domain + '/api/v1/transaction/user_booking?version=1.1&nocache=1&token=' + token);
    }
    return userBooking;
});
sharedServices.factory('userBookingDetail', function($http, config) {
    var userBookingDetail = function(token,leadId) {
        return $http.get(config.domain + '/api/v1/booking/quotedata/'+leadId+'?version=1.1&nocache=1&token=' + token);
    }
    return userBookingDetail;
});
sharedServices.factory('userBookingDetailNew', function($http, config) {
    var userBookingDetailNew = function(token,leadId, booking_hash) {
		console.log(booking_hash);
		if(booking_hash){
			return $http.get(config.domain + "/api/v2/transaction/booking_details/" + leadId + "?token=" + token + "&booking_hash=" + booking_hash);
		}
		else{
			return $http.get(config.domain + "/api/v2/transaction/booking_details/" + leadId + "?token=" + token);
		}
    }
    return userBookingDetailNew;
});
sharedServices.directive("calcHeight",function($timeout) {
   return {
        restrict: 'A',
        scope: {
          'origwidth': '=',
          'origheight': '='
        },
        link: function(scope, element, attrs) {
          var _currentWidth = $(element).width();
          var _aspect_ratio = (1*scope.origwidth)/(1*scope.origheight);
          var _height = _currentWidth * (1/_aspect_ratio);
          $(element).css('height',_height+'px');
        }
    }
})
 // I lazily load the images, when they come into view.
sharedServices.directive("bnLazySrc",function( $window, $document ) {
    // I manage all the images that are currently being
    // monitored on the page for lazy loading.
    var lazyLoader = (function() {
        // I maintain a list of images that lazy-loading
        // and have yet to be rendered.
        var images = [];
        // I define the render timer for the lazy loading
        // images to that the DOM-querying (for offsets)
        // is chunked in groups.
        var renderTimer = null;
        var renderDelay = 100;
        // I cache the window element as a jQuery reference.
        var win = $( $window );
        // I cache the document document height so that
        // we can respond to changes in the height due to
        // dynamic content.
        var doc = $document;
        var documentHeight = doc.height();
        var documentTimer = null;
        var documentDelay = 2000;
        // I determine if the window dimension events
        // (ie. resize, scroll) are currenlty being
        // monitored for changes.
        var isWatchingWindow = false;
        // ---
        // PUBLIC METHODS.
        // ---
        // I start monitoring the given image for visibility
        // and then render it when necessary.
        function addImage( image ) {
            images.push( image );
            if ( ! renderTimer ) {
                startRenderTimer();
            }
            if ( ! isWatchingWindow ) {
                startWatchingWindow();
            }
        }
        // I remove the given image from the render queue.
        function removeImage( image ) {
            // Remove the given image from the render queue.
            for ( var i = 0 ; i < images.length ; i++ ) {
                if ( images[ i ] === image ) {
                    images.splice( i, 1 );
                    break;
                }
            }
            // If removing the given image has cleared the
            // render queue, then we can stop monitoring
            // the window and the image queue.
            if ( ! images.length ) {
                clearRenderTimer();
                stopWatchingWindow();
            }
        }
        // ---
        // PRIVATE METHODS.
        // ---
        // I check the document height to see if it's changed.
        function checkDocumentHeight() {
            // If the render time is currently active, then
            // don't bother getting the document height -
            // it won't actually do anything.
            if ( renderTimer ) {
                return;
            }
            var currentDocumentHeight = doc.height();
            // If the height has not changed, then ignore -
            // no more images could have come into view.
            if ( currentDocumentHeight === documentHeight ) {
                return;
            }
            // Cache the new document height.
            documentHeight = currentDocumentHeight;
            startRenderTimer();
        }
        // I check the lazy-load images that have yet to
        // be rendered.
        function checkImages() {
            // Log here so we can see how often this
            // gets called during page activity.
            var visible = [];
            var hidden = [];
            // Determine the window dimensions.
            var windowHeight = win.height();
            var scrollTop = win.scrollTop();
            // Calculate the viewport offsets.
            var topFoldOffset = scrollTop;
            var bottomFoldOffset = ( topFoldOffset + windowHeight );
            // Query the DOM for layout and seperate the
            // images into two different categories: those
            // that are now in the viewport and those that
            // still remain hidden.
            for ( var i = 0 ; i < images.length ; i++ ) {
                var image = images[ i ];
                if ( image.isVisible( topFoldOffset, bottomFoldOffset ) ) {
                    visible.push( image );
                } else {
                    hidden.push( image );
                }
            }
            // Update the DOM with new image source values.
            for ( var i = 0 ; i < visible.length ; i++ ) {
                visible[ i ].render();
            }
            // Keep the still-hidden images as the new
            // image queue to be monitored.
            images = hidden;
            // Clear the render timer so that it can be set
            // again in response to window changes.
            clearRenderTimer();
            // If we've rendered all the images, then stop
            // monitoring the window for changes.
            if ( ! images.length ) {
                stopWatchingWindow();
            }
        }
        // I clear the render timer so that we can easily
        // check to see if the timer is running.
        function clearRenderTimer() {
            clearTimeout( renderTimer );
            renderTimer = null;
        }
        // I start the render time, allowing more images to
        // be added to the images queue before the render
        // action is executed.
        function startRenderTimer() {
            renderTimer = setTimeout( checkImages, renderDelay );
        }
        // I start watching the window for changes in dimension.
        function startWatchingWindow() {
            isWatchingWindow = true;
            // Listen for window changes.
            win.on( "resize.bnLazySrc", windowChanged );
            win.on( "scroll.bnLazySrc", windowChanged );
            // Set up a timer to watch for document-height changes.
            documentTimer = setInterval( checkDocumentHeight, documentDelay );
        }
        // I stop watching the window for changes in dimension.
        function stopWatchingWindow() {
            isWatchingWindow = false;
            // Stop watching for window changes.
            win.off( "resize.bnLazySrc" );
            win.off( "scroll.bnLazySrc" );
            // Stop watching for document changes.
            clearInterval( documentTimer );
        }
        // I start the render time if the window changes.
        function windowChanged() {
            if ( ! renderTimer ) {
                startRenderTimer();
            }
        }
        // Return the public API.
        return({
            addImage: addImage,
            removeImage: removeImage
        });
    })();
    // ------------------------------------------ //
    // ------------------------------------------ //
    // I represent a single lazy-load image.
    function LazyImage( element ) {
        // I am the interpolated LAZY SRC attribute of
        // the image as reported by AngularJS.
        var source = null;
        // I determine if the image has already been
        // rendered (ie, that it has been exposed to the
        // viewport and the source had been loaded).
        var isRendered = false;
        // I am the cached height of the element. We are
        // going to assume that the image doesn't change
        // height over time.
        var height = null;
        // ---
        // PUBLIC METHODS.
        // ---
        // I determine if the element is above the given
        // fold of the page.
        function isVisible( topFoldOffset, bottomFoldOffset ) {
            // If the element is not visible because it
            // is hidden, don't bother testing it.
            if ( ! element.is( ":visible" ) ) {
                return( false );
            }
            // If the height has not yet been calculated,
            // the cache it for the duration of the page.
            if ( height === null ) {
                height = element.height();
            }
            // Update the dimensions of the element.
            var top = element.offset().top;
            var bottom = ( top + height );
            // Return true if the element is:
            // 1. The top offset is in view.
            // 2. The bottom offset is in view.
            // 3. The element is overlapping the viewport.
            return(
                    (
                        ( top <= bottomFoldOffset ) &&
                        ( top >= topFoldOffset )
                    )
                ||
                    (
                        ( bottom <= bottomFoldOffset ) &&
                        ( bottom >= topFoldOffset )
                    )
                ||
                    (
                        ( top <= topFoldOffset ) &&
                        ( bottom >= bottomFoldOffset )
                    )
            );
        }
        // I move the cached source into the live source.
        function render() {
            isRendered = true;
            renderSource();
        }
        // I set the interpolated source value reported
        // by the directive / AngularJS.
        function setSource( newSource ) {
            source = newSource;
            if ( isRendered ) {
                renderSource();
            }
        }
        // ---
        // PRIVATE METHODS.
        // ---
        // I load the lazy source value into the actual
        // source value of the image element.
        function renderSource() {
            element[ 0 ].src = source;
        }
        // Return the public API.
        return({
            isVisible: isVisible,
            render: render,
            setSource: setSource
        });
    }
    // ------------------------------------------ //
    // ------------------------------------------ //
    // I bind the UI events to the scope.
    function link( $scope, element, attributes ) {
      // this will mimic background-size: cover and center align vertically and horizontally - Aakash
      if ($(element).attr('data-vp')) {
        $(element).css('opacity','0');
        $(element).closest('div').addClass('spinner');
        element.get(0).onload = function() {
          var parentHeight = $(element).closest('div').height()
          var parentWidth = $(element).closest('div').width();
          var width = $(element).width();
          if (width < parentWidth) {
            $(element).removeClass('h-100');
            $(element).css('width','100%');
            var diff = this.height - parentHeight;
            if ( diff > 0) {
              $(element).css('margin-top','-'+diff/2+'px');
            }
          } else {
            var diff = this.width - parentWidth;
            if (diff > 0) {
              $(element).css('margin-left','-'+diff/2+'px');
            }
          }
          $(element).css('opacity','1');
          $(element).closest('div').removeClass('spinner');
        }
      }
      if ($(element).attr('data-mg')) {
        element.get(0).onload = function() {
            $(element).css('height','auto');
        }

      }
      var lazyImage = new LazyImage( element );
      // Start watching the image for changes in its
      // visibility.
      lazyLoader.addImage( lazyImage );
      // Since the lazy-src will likely need some sort
      // of string interpolation, we don't want to
      attributes.$observe(
          "bnLazySrc",
          function( newSource ) {
              lazyImage.setSource( newSource );
          }
      );
      // When the scope is destroyed, we need to remove
      // the image from the render queue.
      $scope.$on(
          "$destroy",
          function() {
              lazyLoader.removeImage( lazyImage );
          }
      );
    }
    // Return the directive configuration.
    return({
        link: link,
        restrict: "A"
    });
  }
);

sharedServices.factory('postAirbnbDetail',function($http,config) {
    var postAirbnbDetail = function(token,description,fullName,email,vacationType) {
        return $http({
            method: 'post',
            url: config.domain + "/api/v1/airbnb?version=1.1&nocache=1&token="+ token,
            data: {
                'vacation_type': vacationType,
                'vacation_description': description,
                'user_name': fullName,
                'user_email': email,
                'status': 1
            }
        });
    }
    return postAirbnbDetail;
});
sharedServices.factory('postAirbnbDetailNext',function($http,config) {
    var postAirbnbDetailNext = function(token,description,fullName,email,vacationType,stepTwoId) {
        return $http({
            method: 'post',
            url: config.domain + "/api/v1/airbnb?version=1.1&nocache=1&token="+ token,
            data: {
                'vacation_type': vacationType,
                'vacation_description': description,
                'user_name': fullName,
                'user_email': email,
                'status': 2,
                'id': stepTwoId
            }
        });
    }
    return postAirbnbDetailNext;
});

sharedServices.factory('sendReview',function($http,config) {
    var sendReview = function(wedding_id,vendor_id,message,category_id,type) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/send_enquiry?version=1.1&nocache=1&token=' + config.token,
            data: {
                'wedding_id': wedding_id,
                'vendor_id': vendor_id,
                'requirements': message,
                'source': 1,
                'category_id': category_id,
                'type': type
            }
        })
    }
    return sendReview;
})

sharedServices.factory('vendorDetail',function($http,config) {
    var vendorDetail = function(token,id) {
        return $http.get(config.domain + '/api/v1/vendor/' + id +'?version=1.1&nocache=1&token=' + token)
    }
    return vendorDetail;
});

sharedServices.factory('submitReview',function($http,config) {
    var submit = function(reviews,vendor_id,date) {
        return $http({
         method: 'post',
         url: config.domain + '/api/v1/post_review?version=1.2&nocache=1&token='+ config.token,
         data: {
         'star_rating': reviews.rating,
         'vendor_id': vendor_id,
         'review_description': reviews.reviewText,
         'hired_date': date,
         'vendor_budget': reviews.money
         }
       })
    }
    return submit;
});

sharedServices.factory('submitStickerReview',function($http,config) {
    var submit = function(reviews,vendor_id,date,stickerID) {
        return $http({
         method: 'post',
         url: config.domain + '/api/v1/post_review?version=1.2&nocache=1&token='+ config.token,
         data: {
         'star_rating': reviews.rating,
         'vendor_id': vendor_id,
         'review_description': reviews.reviewText,
         'hired_date': date,
         'vendor_budget': reviews.money,
         'sticker_id':stickerID
         }
       })
    }
    return submit;
});

sharedServices.factory('GetSticker',function($http,config) {
    var stickers = function(token,id) {
        return $http.get(config.domain + '/api/v1/get_stickers?version=1.1&category_id=' + id +'&token=' + token)
    }
    return stickers;
});

sharedServices.factory('transactionnBook',function($http,config) {
    var transactionnBook = function(token,vendor_id,data,type) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/transaction/bookvenue?version=1.1&nocache=1&token='+token+'&vendor_id='+vendor_id,
            data: {
                'vendor_id': vendor_id,
                'requirement_json' : data,
                'status' : 8,
                'type': type
            }
        })
    }
    return transactionnBook;
});
sharedServices.factory('bookFreeService',function($http,config) {
  var bookFreeService = function(token,data) {
    return $http({
      method: 'post',
      url: config.domain + '/api/v1/transaction/bookvenue?version=1.1&nocache=1&token='+token,
      data: {
          'requirement_json' : data,
          'status' : 12,
      }
    })
  }
  return bookFreeService;
})
sharedServices.factory('transactionnBookFinal',function($http,config) {
    var transactionnBookFinal = function(token, data, vendor_id, price, bookingLeadId,status,type) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/transaction/bookvenue?version=1.1&nocache=1&token='+token+'&vendor_id='+vendor_id,
            data: {
                'vendor_id': vendor_id,
                'requirement_json' : data,
                'status' : status,
                'booking_lead_id' : bookingLeadId,
                'set_calculated_price': price,
                'type': type
            }
        })
    }
    return transactionnBookFinal;
});

sharedServices.factory('getPreferencesAdmin',function($http,config) {
    var getPreferences = function(token,vendor_id,category_id,user_id) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/booking/getpreferences?nocache=1&token='+token,
            data: {
                'vendor_id': vendor_id,
                'vendor_category_id': category_id,
                'user_profile_id': user_id,
                'admin_call': true
            }
        })
    }
    return getPreferences;
});

sharedServices.factory('getPreferences',function($http,config) {
    var getPreferences = function(token,vendor_id,category_id) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/booking/getpreferences?nocache=1&token='+token,
            data: {
                'vendor_id': vendor_id,
                'vendor_category_id': category_id
            }
        })
    }
    return getPreferences;
});

sharedServices.factory('contactClicked',function($http,config) {
  var contactClicked = function(vendor_id,status) {
    return $http({
      method: 'get',
      url: config.domain + '/api/v1/contact_click?version=1.1&token='+ config.token + '&vendor_id='+vendor_id+'&status='+status,
    })
  }
  return contactClicked;
})

sharedServices.factory('savePreferences',function($http,config) {
    var savePreferences = function(token,vendor_id,category_id,step,answers,func_details,bookingLeadId) {
        if (step == '1') {
            return $http({
                method: 'post',
                url: config.domain + '/api/v1/booking/savepreferences?nocache=1&token='+token,
                data: {
                    'vendor_id': vendor_id,
                    'vendor_category_id': category_id,
                    'step': step,
                    'user_answers': answers
                }
            })
        } else if (step == '2') {
            return $http({
                method: 'post',
                url: config.domain + '/api/v1/booking/savepreferences?nocache=1&token='+token,
                data: {
                    'vendor_id': vendor_id,
                    'vendor_category_id': category_id,
                    'step': step,
                    'booking_lead_id': bookingLeadId,
                    'user_function_details': func_details
                }
            })
        } else {
            return $http({
                method: 'post',
                url: config.domain + '/api/v1/booking/savepreferences?nocache=1&token='+token,
                data: {
                    'vendor_id': vendor_id,
                    'vendor_category_id': category_id,
                    'step': step,
                    'booking_lead_id': bookingLeadId,
                    'user_answers': answers
                }
            })
        }
    }
    return savePreferences;
})

sharedServices.factory('getQuotePreference',function($http,config) {
    var getQuotePreference = function(token,vendor_id,category_id,price,bookingLeadId,addInfo) {
    return $http({
            method: 'post',
            url: config.domain + '/api/v1/booking/getquote?nocache=1&token='+token,
            data: {
                'vendor_id': vendor_id,
                'vendor_category': category_id,
                'calculated_price': price,
                'booking_lead_id': bookingLeadId,
                'notes': addInfo
            }
        })
    }
    return getQuotePreference;
});

sharedServices.factory('vendorLogin',function($http,config){
    var vendorLogin = function(username,password,token) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/vendor/login?nocache=1&version=1.1&token='+token,
            ignoreLoadingBar: true,
            data: {
                'username': username,
                'password': password
            }
        })
    }
    return vendorLogin;
});

sharedServices.factory('fetchNumbers', ['$http','config', function($http,config){
  return function fetchNumbers(vendor_id,status){
    return $http.get(config.domain + '/api/v1/vendor/'+vendor_id+'/mobile?version=1.1&token=' + config.token + '&status=' + status)
  };
}])

sharedServices.factory('vendorDashboard',function($http,config){
    var vendorDashboard = function(token) {
        return $http.get(config.domain + '/api/v1/vendor/dashboard?nocache=1&version=1.1&token='+token)
    }
    return vendorDashboard;
});

sharedServices.factory('vendorGst', ['$http', 'config', function($http, config){
	var vendorGst = function(token, data){
		// console.log('factory', token, data);
		return $http({
			method: 'POST',
			url: config.domain + '/api/v1/vendor/save_business_detail?token=' + token,
			data: data
		});
	}
	return vendorGst;
}]);


sharedServices.factory('briadalAsiaPost',function($http,config){
    var briadalAsiaPost = function(name,email,consultant) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/bridalasia?version=1.1&token='+config.token,
            ignoreLoadingBar: true,
            data: {
                'name': name,
                'email': email,
                'status': consultant
            }
        })
    }
    return briadalAsiaPost;
});
sharedServices.factory('toggleLovePost',function($http,config){
    var toggleLovePost = function(token,data) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/love?version=1.1&token='+token,
            data: data
        })
    }
    return toggleLovePost;
});

sharedServices.factory('UberPost',function($http,config) {
    var UberPost = function(token,name,mobile,guests,rides) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/ext/add_uber_details?token='+token,
            data: {
              name: name,
              mobile_number: mobile,
              guests_count: guests,
              rides_count: rides
            }
        })
    }
    return UberPost;
});

sharedServices.factory('sendOtpMobile', ['$http','config', function($http,config) {
  var sendOtp = function(phone_no,is_international) {
    return $http({
      method: 'post',
      url: config.domain + '/api/v1/user/sendotp?version=1.1&token='+ config.token,
      data: {
        'mobile_number' : phone_no,
        'is_international': is_international
      }
    })
  }
  return sendOtp;
}])

sharedServices.factory('verifyMobile', ['$http','config', function($http,config){
  return function verifymobile(phone_no,otpCode) {
    return $http({
      method: 'post',
      url: config.domain + '/api/v1/user/verifymobile?version=1.1&token=' + config.token,
      data: {
        'mobile_number': phone_no,
        'otp': otpCode
      }
    })
  };
}])
sharedServices.factory('albumDetail', function($http,$timeout,config) {
  var getAlbumDetail = function(slug,resource_type,vendor_id) {
    this.busy = false;
    this.items = [];
    this.after = '';
    this.noData = false;
    this.token = config.token;
    this.flag = 0;
    this.resource_type = resource_type;
    this.slug = slug;
    this.vendor_id = vendor_id;
    this.album_details = {};
    this.profile = {};
    this.dataFound = false;
  }
  getAlbumDetail.prototype.callAPI = function() {
    if (this.busy) return;
      this.busy = true;
    if (this.resource_type == 'member') {
      $http({
       method: 'post',
       url: config.domain + '/api/v1/vendor_album_images?version=1.1&nocache=1&token='+ this.token,
       data: {
          'slug': this.slug,
          'resource_name':this.resource_type,
       }
      }).then(function(data) {
        albumDetailCallback(data,this);
      }.bind(this))
    } else if (this.resource_type == 'project') {
      $http({
       method: 'post',
       url: config.domain + '/api/v1/vendor_album_images?version=1.1&nocache=1&token='+ this.token,
       data: {
          'resource_name':this.resource_type,
          'resource_id':this.vendor_id
       }
      }).then(function(data) {
        albumDetailCallback(data,this);
      }.bind(this))
    }
    var albumDetailCallback = function(data,that) {
      if( data.data.data ) {
        data.data.data.images.forEach(function(obj){
          var desc = obj,
          width = desc.image_width,
          height = desc.image_height;
          imageUrl = desc.image_url ? desc.image_url.replace('%%','400') : desc.image_url;
          obj.actualHeight  = height;
          obj.actualWidth = width;
          obj.actualImageUrl = imageUrl;
        });
        var items = data.data.data.images;
        that.profile = data.data.data.profile;
        that.album_details = data.data.data.album_details;
        that.seo_data = data.data.data.seoData;
        for (var i = 0; i < items.length; i++) {
          that.items.push(items[i]);
        }
        that.noData = false;
        that.flag = 1;
        that.busy = false;
        that.dataFound = true;
        $timeout(function() {
          if (data.data.data.images.length == 1) {
            $('.deckgrid').find('.column').removeClass('column-1-4');
          } else {
            $('.deckgrid').find('.column').addClass('column-1-4');
          }
          if (window.location.href.indexOf('admin') == -1) {
            $('img').bind('contextmenu', function(e) {
              return false;
            });
          }
        },500)
      } else {
        that.noData = true;
        //this.busy = "Oops NO Data Found";
      }
    };
  };
  return getAlbumDetail;
});


sharedServices.factory('VendorPageSeo', ['$http','config', function($http,config){
     var seodata =  function (vendor_id){
        return $http.get(config.domain + '/api/v1/vendor/'+vendor_id+'/seo')
     };
     return seodata;
}]);

sharedServices.factory('bookingPayment', function($http, config) {
    var bookingPayment = function(token,paymentData) {
        return $http({
            method: 'post',
            url: config.domain + '/api/v1/user/book/partymakeup?token=' + token,
            data: paymentData
        })
    }
    return  bookingPayment;
});

// sharedServices.factory('albumDetail',function($http,config) {
//     var albumDetailData = function(slug,resource_type,vendor_id) {
//       if (resource_type == 'member') {
//         return $http({
//          method: 'post',
//          url: config.domain + '/api/v1/vendor_album_images?version=1.1&nocache=1&token='+ token,
//          data: {
//             'slug': slug,
//             'resource_name':resource_type,
//             'resource_id':vendor_id
//          }
//         })
//       } else if (resource_type == 'project') {
//         return $http({
//          method: 'post',
//          url: config.domain + '/api/v1/vendor_album_images?version=1.1&nocache=1&token='+ token,
//          data: {
//             'resource_name':resource_type,
//             'resource_id':vendor_id
//          }
//         })
//       }
//     }
//     return albumDetailData;
// });
